function normalizeMs(arr) {
  if (!Array.isArray(arr)) return []
  return [...new Set(arr.map((k) => String(k).toUpperCase()))].sort()
}

export function questionPoints(question) {
  if (typeof question.points === 'number') return question.points
  return question.id <= 20 ? 2 : 3
}

export function isAnswerCorrect(question, userValue) {
  if (userValue === null || userValue === undefined) return false
  if (question.type === 'tf') {
    return typeof userValue === 'boolean' && userValue === question.correct
  }
  if (question.type === 'mc') {
    return typeof userValue === 'string' && userValue.toUpperCase() === question.correct
  }
  if (question.type === 'ms') {
    const a = normalizeMs(userValue)
    const b = normalizeMs(question.correct)
    if (a.length !== b.length) return false
    return a.every((k, i) => k === b[i])
  }
  return false
}

const WRONG_PENALTY = 1

/**
 * Core questions (1–20): +2 each if correct. Advanced (21–40): +3 each if correct.
 * Each incorrect answer: −1. Maximum raw score 100.
 */
export function scoreCertification(questions, answersById) {
  let correct = 0
  let pointsEarned = 0
  const wrong = []

  for (const q of questions) {
    const userValue = answersById[q.id]
    const ok = isAnswerCorrect(q, userValue)
    const pts = questionPoints(q)
    if (ok) {
      correct += 1
      pointsEarned += pts
    } else {
      wrong.push({ question: q, userValue })
    }
  }

  const wrongCount = wrong.length
  const penaltyTotal = wrongCount * WRONG_PENALTY
  const rawScore = pointsEarned - penaltyTotal

  const maxPoints = questions.reduce((sum, q) => sum + questionPoints(q), 0)

  return {
    correct,
    total: questions.length,
    wrong,
    wrongCount,
    pointsEarned,
    penaltyTotal,
    rawScore,
    maxPoints,
    wrongPenaltyPerQuestion: WRONG_PENALTY
  }
}

export function formatUserAnswer(question, userValue) {
  if (userValue === null || userValue === undefined) return '— (no answer)'
  if (question.type === 'tf') return userValue === true ? 'True' : 'False'
  if (question.type === 'mc') return String(userValue).toUpperCase()
  if (question.type === 'ms') return normalizeMs(userValue).join(', ') || '— (none selected)'
  return String(userValue)
}

export function formatCorrectAnswer(question) {
  if (question.type === 'tf') return question.correct ? 'True' : 'False'
  if (question.type === 'mc') return question.correct
  if (question.type === 'ms') return question.correct.join(', ')
  return ''
}
